import { message } from "antd";
import { useAuthContext } from "../context/auth-context";

export default function useHttpClient() {
    const { token, logout } = useAuthContext();

    const caseStatus = (status, responseData) => {
        switch (status) {
            case 200:
                return responseData
            case 204:
                return null
            default:
                {
                    const keys = Object.keys(responseData)
                    const messages = Object.values(responseData)
                    messages.forEach((error, i) => { message.error(`${keys[i]} : ${error}`) });
                }
        }
        return null
    }

    const sendRequest = async ({ endpoint, method, bodyData }) => {
        let returnValue;
        const fetchBody = bodyData ? JSON.stringify(bodyData) : null;
        try {
            const response = await fetch(
                endpoint, {
                method,
                body: fetchBody,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'content-type': 'application/json',
                    'Accept': 'application/json'
                },
            })
            const status = await response.status
            if (status === 401) {
                logout()
            }
            if (status === 204) {
                returnValue = caseStatus(status, null)
            }
            else {
                const responseData = await response.json()
                returnValue = caseStatus(status, responseData)
            }
        } catch (error) {
            message.error('Πρόβλημα στο δίκτυο');
            message.error("Κάτι πήγε Στραβά")
        }
        return returnValue
    }
    return { sendRequest }
}